import { useEffect, useRef } from 'react';
import { eventBus } from '../eventBus';
export function useEventSubscribe(event, handler, deps = []) {
    const handlerRef = useRef(handler);
    useEffect(() => {
        handlerRef.current = handler;
    }, [handler, ...deps]);
    useEffect(() => {
        const listener = ((payload) => {
            handlerRef.current(payload);
        });
        return eventBus.on(event, listener);
    }, [event]);
}
export function useEventSubscribeOnce(event, handler, deps = []) {
    const handlerRef = useRef(handler);
    const calledRef = useRef(false);
    useEffect(() => {
        handlerRef.current = handler;
    }, [handler, ...deps]);
    useEffect(() => {
        calledRef.current = false;
        const listener = ((payload) => {
            if (!calledRef.current) {
                calledRef.current = true;
                handlerRef.current(payload);
            }
        });
        return eventBus.on(event, listener);
    }, [event]);
}
